import React from 'react';
import { TablePagination as MuiTablePagination } from '@mui/material';

const TablePagination = ({
  page,
  rowsPerPage,
  totalCount,
  onPageChange,
  onRowsPerPageChange
}) => {
  // MUI's TablePagination is 0-based, but we want 1-based for our API
  const handlePageChange = (event, newPage) => {
    onPageChange(newPage + 1);
  };

  const handleRowsPerPageChange = (event) => {
    onRowsPerPageChange(parseInt(event.target.value, 10));
  };

  return (
    <MuiTablePagination
      component="div"
      count={totalCount}
      page={page - 1} // Convert 1-based to 0-based for MUI
      onPageChange={handlePageChange}
      rowsPerPage={rowsPerPage}
      onRowsPerPageChange={handleRowsPerPageChange}
      rowsPerPageOptions={[25, 50, 75, 100]}
      showFirstButton
      showLastButton
    />
  );
};

export default TablePagination;
